import React from 'react'
import queryLessonResult from '../../../../Model/QueryResult/useLessonResult'
import { useDispatch, useSelector } from 'react-redux'
import { useMutation, gql } from '@apollo/client'
import { SET_DATA_MODAL_FORM_LIST } from '../../../../store/modal/const'
import {
    ConfirmModal,
    Activity
} from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../i18n/useTranslation'
import { showAlert } from '../../../../common/Alert/util'

const ConfirmResetVirtualClassRoom = () => {
    const {translate} = useTranslation()
    const dispatch = useDispatch()
    const reduxData = useSelector((state) => state.modal.plan.resetVirtualClassRoom)
    const {isOpen, lessonId, isOrientation} = reduxData

    const toggle = () => {
        dispatch({
            type: SET_DATA_MODAL_FORM_LIST,
            payload: 'plan.resetVirtualClassRoom',
            data: {
              ...reduxData,
              isOpen: !isOpen
            }
        })
    }
    const [resetVirtualClassRoom, {loading}] = useMutation(
        gql`
            mutation update($lessonId: String!) {
                resetVirtualClassRoom(lessonId: $lessonId) {
                    ${queryLessonResult}
                }
            }
        `
    )
    return(
        <ConfirmModal
            className=''
            classNameActionDiv='flex-column'
            classNameConfirm='text-right text-error'
            classNameCancel='mx-3 text-right'
            isOpen={isOpen}
            toggle={toggle}
            title={translate('modal.setbraincert.title')}
            body={translate("modal.setbraincert.body")}
            confirmAction={() => {
                resetVirtualClassRoom({
                    variables: {lessonId}
                }).then(({data: {resetVirtualClassRoom}}) => {
                    isOrientation ? 
                    dispatch({
                        type: SET_DATA_MODAL_FORM_LIST,
                        payload: 'plan.infoLessonModal',
                        data: {
                          isOpen: false,
                          dataLesson: resetVirtualClassRoom
                        }
                    })
                    : dispatch({
                        type: SET_DATA_MODAL_FORM_LIST,
                        payload: 'plan.infoLessonModal',
                        data: {
                          isOpen: true,
                          dataLesson: resetVirtualClassRoom
                        }
                    })
                    toggle()
                }, (err) => {
                    showAlert({
                        text: err,
                        status: "error"
                    }, dispatch)
                })
            }}
            cancelAction={loading ? null : toggle}
            confirmText={loading ? <Activity /> : translate("modal.setbraincert.confirm")}
            cancelText={loading ? null : "Cancel"}
        />
    )
}

export default ConfirmResetVirtualClassRoom
